export const containerStylesWebView = `
    w-full h-full flex flex-col
`

export const bodyContainerStylesWebView = `
    flex flex-col items-center 
    flex-grow flex-shrink-0 
    p-[48px]
`

export const titleStylesWebView = `
    launching-mode-title
`

export const descriptionStylesWebView = `
    launching-mode-description mt-[24px]
`

export const footerTextStylesWebView = `
    text-sm-regular ml-auto 
    mr-[40px] mb-[20px]
`

export const containerStylesMobileView = `
    w-full h-full flex flex-col 
    gap-y-[24px]
`

export const bodyContainerStylesMobileView = `
    flex flex-col items-center 
    flex-grow flex-shrink-0 
    p-[24px]
`

export const titleStylesMobileView = `
    launching-mode-title-mobile-view
`

export const descriptionStylesMobileView = `
    launching-mode-description-mobile-view mt-[24px]
`

export const footerTextStylesMobileView = `
    text-sm-regular text-center 
    mb-[20px]
`
